<template>
    <loading v-if="isLoading" />
    <v-form v-else v-model="isFormValid" ref="form">
        <v-container>
            <h1 class="display-1 text-center base-header pa-4">
                Fill in form
            </h1>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" md="4">
                        <v-card class="elevation-12 rounded form-card mt-n6">
                            <v-col>
                                <v-text-field v-model.number="amount" color="teal" :rules="amountRules" type="number" label="Amount *" required></v-text-field>
                            </v-col>

                            <v-col>
                                <v-row align="center" justify="center">
                                    <v-btn class="" color="teal" @click="changeNumberSign()">
                                        +/-
                                    </v-btn>
                                    <v-btn class="ml-4" color="teal" @click="changeTVA()">
                                        {{ tvaButtonText }}
                                    </v-btn>
                                    <v-btn class="ml-4" color="teal" @click="changeTransferType()">
                                        {{ transferText }}
                                    </v-btn>
                                </v-row>
                            </v-col>

                            <v-col>
                                <v-text-field v-model="description" :rules="descriptionRules" color="teal" label="Description *" required></v-text-field>
                            </v-col>

                            <v-col>
                                <v-dialog v-model="isDateSelected" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="date" label="Date Selector" readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="date" @input="isDateSelected = false" color="teal" :first-day-of-week="1" scrollable> </v-date-picker>
                                </v-dialog>
                            </v-col>

                            <v-col>
                                <v-file-input accept=".jpg,.jpeg,.png,.pdf" color="teal" @change="saveImageOffline()" label="File input" v-model="file"></v-file-input>
                            </v-col>

                            <v-col>
                                <v-select2 v-model="selectedSheet" :options="sheetsValues" placeholder="Select your sheet"></v-select2>
                            </v-col>

                            <v-col align="center" justify="center">
                                <v-btn class="mb-4" width="100%" :loading="isLoading" :disabled="!isFormValid" color="teal" @click="sendData()">
                                    Upload
                                </v-btn>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </v-form>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Loading from '@/components/layouts/Loading.vue';

    export default {
        components: {
            Loading,
        },
        data: () => ({
            isFormValid: false,
            amount: '',
            amountRules: [
                (value) => {
                    const pattern = /^-?[0-9]+[.,][0-9]{2}$/;
                    return pattern.test(value) || 'Numbers only with 2 decimals';
                },
            ],
            description: '',
            descriptionRules: [(value) => !!value || 'Description is required'],
            date: new Date().toISOString().substr(0, 10),
            formattedDate: '',
            isDateSelected: false,
            isTva: false,
            tvaButtonText: 'Only TVA',
            selectedSheet: null,
            file: null,
            isTransfer: false,
            transferType: 'receive',
            transferText: 'to receive',
            sheetsValues: [],
            imageBase: null,
        }),
        watch: {
            $online() {
                if (this.$online) {
                    let list = this.getDataFromLocalStorage();
                    if (list) {
                        list.forEach((item) => {
                            let formdata = this.createFormDataFromItem(item);
                            this.fetchReceiptDetails(formdata).then(() => {
                                this.clearStorage();
                                localStorage.removeItem('list');
                                // let curentItem = list.find((i) => i.id == item.id);
                                // let index = list.indexOf(curentItem);
                                // list.splice(index, 1);
                            });
                        });
                        // localStorage.setItem('list', JSON.stringify(list));
                    }

                    // this.OfflineformData.forEach((data) => {
                    //     this.fetchReceiptDetails(data);
                    // });
                }
            },
        },

        computed: {
            ...mapGetters({
                sheets: ['getSheets'],
                isLoading: ['getIsLoading'],
                isIOSDevice: ['getIsIosDevice'],
            }),
        },

        methods: {
            formatData() {
                this.amount = this.amount.toString().replace(/,/g, '.');
            },
            // checkImage(file) {
            //     if (this.file) {
            //         console.log('vankep');

            //         const reader = new FileReader();
            //         reader.addEventListener('load', () => {
            //             localStorage.setItem('recent-image', reader.result);
            //             console.log('image', reader.result);
            //         });
            //         reader.readAsDataURL(this.file);
            //     }
            // },

            setDataInLocalStorage() {
                let list = localStorage.getItem('list');

                if (!list) {
                    list = [];
                } else {
                    list = JSON.parse(list);
                }
                let count = list.length;

                list.push({
                    amount: this.amount,
                    description: this.description,
                    date: this.date,
                    isTva: this.isTva ? '1' : '0',
                    selectedSheet: this.selectedSheet,
                    transferType: this.transferType,
                    file: this.imageBase || null,
                    id: ++count,
                });
                localStorage.setItem('list', JSON.stringify(list));
            },
            getDataFromLocalStorage() {
                let list = localStorage.getItem('list');

                console.log(list, 'list');
                if (list) {
                    list = JSON.parse(list);
                    console.log('list', list);
                    // var OfflineformData = new FormData();
                }
                return list;

                // OfflineformData.append('amount', this.amount1);
                // OfflineformData.append('description', this.description1);
                // OfflineformData.append('transfer_type', this.transferType1);

                // OfflineformData.append('tva', this.isTva1);
                // OfflineformData.append('date', this.date1);
                // OfflineformData.append('sheet_name', this.selectedSheet1);
                // console.log('offlineformdata', OfflineformData.amount, OfflineformData.description);
            },
            // createOfflineData() {},

            changeNumberSign() {
                this.amount = this.amount.toString().replace(/,/g, '.');
                this.amount = this.amount * -1;
            },
            saveImageOffline() {
                let reader = new FileReader();
                if (this.file) {
                    // const reader = new FileReader();
                    // reader.readAsDataURL(this.file);
                    // console.log('64baseiomage', reader.result);
                    console.log('vankep');

                    reader.addEventListener('load', () => {
                        this.imageBase = reader.result;
                        console.log('iamgebase64', this.imageBase);
                    });
                    console.log('image64 scopen kivul', this.imageBase);
                    reader.readAsDataURL(this.file);
                }
                console.log(this.file, 'kep');
            },

            changeTVA() {
                this.isTva = !this.isTva;
                this.isTva ? (this.tvaButtonText = 'Whole') : (this.tvaButtonText = 'Only TVA');
            },

            changeTransferType() {
                this.isTransfer = !this.isTransfer;
                this.isTransfer ? (this.transferType = 'received') && (this.transferText = 'received') : (this.transferType = 'receive') && (this.transferText = 'to receive');
            },

            resetForm() {
                this.$refs.form.reset();
                this.date = new Date().toISOString().substr(0, 10);
            },

            createFormDataObject() {
                let formData = new FormData();

                formData.append('amount', this.amount);
                formData.append('description', this.description);
                formData.append('transfer_type', this.transferType);
                this.isTva ? (this.isTva = '1') : (this.isTva = '0');
                formData.append('tva', this.isTva);
                formData.append('date', this.date);
                formData.append('sheet_name', this.selectedSheet);

                if (this.file) {
                    formData.append('filename', this.file);
                }

                this.fetchReceiptDetails(formData);
            },
            createFormDataFromItem(item) {
                let formData = new FormData();

                formData.append('amount', item.amount);
                formData.append('description', item.description);
                formData.append('transfer_type', item.transferType);
                item.isTva ? (item.isTva = '1') : (item.isTva = '0');
                formData.append('tva', item.isTva);
                formData.append('date', item.date);
                formData.append('sheet_name', item.selectedSheet);

                if (this.file) {
                    formData.append('filename', item.file);
                }

                return formData;
            },

            sendData() {
                this.formatData();

                this.createFormDataObject();

                if (!this.$online) {
                    this.setDataInLocalStorage();
                }

                this.resetForm();
            },
            clearStorage() {
                console.log('storage cleared');
                localStorage.removeItem('list');
                console.log('storage cleared');
            },

            async getSheets() {
                await this.fetchSheets().then(() => {
                    this.sheetsValues = Object.values(this.sheets);
                });
            },

            ...mapActions(['form/', 'fetchSheets']),
            ...mapActions(['form/', 'fetchReceiptDetails']),
            ...mapActions(['notification/', 'showNotification']),
        },

        mounted() {
            this.getSheets();
            console.log(this.file);
            // this.getDataFromLocalStorage();
            // this.createOfflineData();
        },
    };
</script>

<style lang="scss" scoped>
    .base-header {
        font-family: Bariol !important;
        font-style: normal;
        font-weight: bold;
        letter-spacing: 0.5px !important;
    }

    .form-card {
        background: #ffffff !important ;
        box-shadow: 2px 1px 10px rgba(205, 205, 212, 0.1) !important;
        border-radius: 5px !important;
        filter: drop-shadow(2px 1px 10px rgba(162, 162, 162, 0.25));
    }
</style>
